import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const ECommerceWebsite = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    'Product listing & filters',
    'Cart & checkout',
    'Online payments',
    'Order management',
    'Inventory tracking',
    'Customer login',
    'Admin dashboard',
    'Coupons & offers',
    'SEO-optimized store'
  ];

  const perfectFor = [
    'Fashion brands',
    'Small stores',
    'Supermarkets',
    'Electronics shops',
    'D2C brands'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">E-Commerce Website Development</h1>
          <p className="service-hero-tagline">Launch a powerful online store built to convert customers.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We build e-commerce websites with product management, secure payments, admin systems, inventory tracking, 
            and smooth checkout flow.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Features Included</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Perfect For</h2>
          <div className="ideal-for-list">
            {perfectFor.map((item, index) => (
              <div key={index} className="ideal-item" data-aos="fade-up" data-aos-delay={index * 100}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Launch My Online Store →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ECommerceWebsite;

